import { deserialize } from 'libs/cerialize';

export class CanvasExecutionResultModel {
	@deserialize
	PackageId: number;

	@deserialize
	InsertRecords: number;

	@deserialize
	UpdateRecords: number;
}
